// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[0].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[0].use[2]!../node_modules/quill/dist/quill.snow.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* You can add global styles to this file, and also import other style files */
:root {
  --mdc-checkbox-selected-checkmark-color: white;
}

html,
body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.gymfinder-card {
  margin-top: 2em;
}

.flex-row, .flex-column {
  display: flex;
  flex-wrap: wrap;
}

.flex-column {
  flex-direction: column;
}

.flex-fixed {
  flex-grow: 0;
  flex-shrink: 0;
}

.flex-grow {
  flex-grow: 1;
  flex-shrink: 1;
}

.flex-40 {
  flex-basis: 40%;
}

.flex-50 {
  flex-basis: 50%;
}

.flex-100 {
  flex-basis: 100%;
}

.flex-align-center {
  align-items: center;
}

.form-column {
  margin-right: 1em;
}

.form-column:last-of-type {
  margin-right: 0;
}

.form-row {
  margin: 1em 0;
}

.toolbar-subtitle {
  margin: 1em 0;
}

.toolbar-subtitle:first-of-type {
  margin-top: 0;
}

.w-100 {
  width: 100%;
}

body .gymfinder .mat-toolbar {
  background-color: whitesmoke;
}
body .mat-toolbar {
  font-size: 20px;
}
body .mat-toolbar h1,
body .mat-toolbar h2 {
  font-size: 20px;
}
body .mat-mdc-card-title {
  font-size: 20px;
  margin-bottom: 12px;
}
body .mat-mdc-card {
  padding: 1em 1em 0 1em;
}
body .mat-mdc-card-content {
  padding: 0;
}
body .toolbar-subtitle {
  margin-bottom: 16px;
}

.breadcrumb {
  align-items: center;
  display: flex;
}

div.mat-mdc-select-panel.filter-select-panel {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
}

.filter-select-panel .filter-select-panel__header {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 12px;
  background: var(--mat-select-panel-background-color, var(--mat-sys-surface-container, #fff));
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.filter-select-panel .filter-select-panel__options {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  position: relative;
  padding: 8px 0;
}
.filter-select-panel .filter-select-panel__search {
  display: flex;
  align-items: center;
  gap: 8px;
}
.filter-select-panel .filter-select-panel__search-input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font: inherit;
  padding: 4px 0;
}
.filter-select-panel .filter-select-panel__bulk {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.filter-select-panel .filter-select-panel__empty {
  padding: 12px;
  opacity: 0.6;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/styles.scss"],"names":[],"mappings":"AAAA,8EAAA;AAGA;EACE,8CAAA;AAAF;;AAGA;;EAEE,YAAA;AAAF;;AAEA;EACE,SAAA;EACA,iDAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAGA;EACE,aAAA;EACA,eAAA;AAAF;;AAGA;EAEE,sBAAA;AADF;;AAIA;EACE,YAAA;EACA,cAAA;AADF;;AAIA;EACE,YAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAOA;EACE,WAAA;AAJF;;AASE;EACE,4BAAA;AANJ;AASE;EACE,eAAA;AAPJ;AAQI;;EAEE,eAAA;AANN;AAUE;EACE,eAAA;EACA,mBAAA;AARJ;AAWE;EACE,sBAAA;AATJ;AAYE;EACE,UAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;;AAeA;EACE,mBAAA;EACA,aAAA;AAZF;;AAsBA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,UAAA;AAnBF;;AAuBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,4FAAA;EAIA,4CAAA;AAvBJ;AA0BE;EACE,cAAA;EACA,aAAA;EACA,cAAA;EAGA,kBAAA;EACA,cAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA3BJ;AA8BE;EACE,OAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;AA5BJ;AA+BE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA7BJ;AAgCE;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AA9BJ","sourcesContent":["/* You can add global styles to this file, and also import other style files */\n@import 'quill/dist/quill.snow.css';\n\n:root {\n  --mdc-checkbox-selected-checkmark-color: white;\n}\n\nhtml,\nbody {\n  height: 100%;\n}\nbody {\n  margin: 0;\n  font-family: Roboto, 'Helvetica Neue', sans-serif;\n}\n\n.gymfinder-card {\n  margin-top: 2em;\n}\n\n// SECTION FLEX DISPLAY\n.flex-row {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.flex-column {\n  @extend .flex-row;\n  flex-direction: column;\n}\n\n.flex-fixed {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.flex-grow {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n\n.flex-40 {\n  flex-basis: 40%;\n}\n\n.flex-50 {\n  flex-basis: 50%;\n}\n\n.flex-100 {\n  flex-basis: 100%;\n}\n\n.flex-align-center {\n  align-items: center;\n}\n\n// SECTION FORM\n.form-column {\n  margin-right: 1em;\n}\n\n.form-column:last-of-type {\n  margin-right: 0;\n}\n\n.form-row {\n  margin: 1em 0;\n}\n\n// SECTION TOOLBAR\n.toolbar-subtitle {\n  margin: 1em 0;\n}\n\n.toolbar-subtitle:first-of-type {\n  margin-top: 0;\n}\n\n//SECTION GENERAL LAYOUT\n.w-100 {\n  width: 100%;\n}\n\n//SECTION - OVERWRITE MATERIAL DESIGN COMPONENTS\nbody {\n  .gymfinder .mat-toolbar {\n    background-color: whitesmoke;\n  }\n\n  .mat-toolbar {\n    font-size: 20px;\n    h1,\n    h2 {\n      font-size: 20px;\n    }\n  }\n\n  .mat-mdc-card-title {\n    font-size: 20px;\n    margin-bottom: 12px;\n  }\n\n  .mat-mdc-card {\n    padding: 1em 1em 0 1em;\n  }\n\n  .mat-mdc-card-content {\n    padding: 0;\n  }\n\n  .toolbar-subtitle {\n    margin-bottom: 16px;\n  }\n}\n\n.breadcrumb {\n  align-items: center;\n  display: flex;\n}\n\n// \"Selected Filters\" multi-select panel (rendered in the CDK overlay, so the\n// styles must live globally rather than in the component stylesheet).\n//\n// The panel itself must not scroll. If it did, the header would have to be\n// `position: sticky` and the options would slide *underneath* it; instead the\n// header is a fixed row and the options get their own scroll container, so the\n// list is clipped below the header and can never overlap it.\ndiv.mat-mdc-select-panel.filter-select-panel {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 0;\n}\n\n.filter-select-panel {\n  .filter-select-panel__header {\n    flex: 0 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding: 8px 12px;\n    background: var(\n      --mat-select-panel-background-color,\n      var(--mat-sys-surface-container, #fff)\n    );\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n  }\n\n  .filter-select-panel__options {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: auto;\n    // Makes this the offset parent for the options, so `offsetTop` is measured\n    // against the list rather than the panel.\n    position: relative;\n    padding: 8px 0;\n  }\n\n  .filter-select-panel__search {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .filter-select-panel__search-input {\n    flex: 1;\n    min-width: 0;\n    border: none;\n    outline: none;\n    background: transparent;\n    font: inherit;\n    padding: 4px 0;\n  }\n\n  .filter-select-panel__bulk {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n  }\n\n  .filter-select-panel__empty {\n    padding: 12px;\n    opacity: 0.6;\n    font-style: italic;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
